export type StyleId =
  | 'midnight'
  | 'dark-contours'
  | 'light-contours'
  | 'blueprint'
  | 'tangerine'
  | 'satellite'
  | 'sepia'
  | 'old-world'
  | 'outline';

export interface MapStyle {
  id: StyleId;
  name: string;
  /** Name stored on v1 orders (and shown in the old admin). */
  legacyName: string;
  mapbox: string;
  /** Poster background (margin and text panel). */
  bg: string;
  /** Frame lines around the map and the text panel. */
  frame: string;
  /** Poster text. */
  ink: string;
  /** Route line. */
  route: string;
  /** Elevation profile fill. */
  elevation: string;
  /** Map label text and dots. */
  label: string;
  logo: 'white' | 'black';
  swatch: string;
}

const mb = (id: string) => `mapbox://styles/trailmapsuk/${id}`;

export const STYLES: MapStyle[] = [
  { id: 'midnight', name: 'Midnight', legacyName: 'Midnight', mapbox: mb('ck2n3g96v01uw1cobmghtifba'), bg: '#000000', frame: '#000000', ink: '#FFFFFF', route: '#FFFFFF', elevation: '#FFFFFF', label: '#FFFFFF', logo: 'white', swatch: 'img/midnight.jpg' },
  { id: 'dark-contours', name: 'Dark Contours', legacyName: 'Dark Contours', mapbox: mb('ckjyck9r51u4k17pc9gifspyr'), bg: '#000000', frame: '#000000', ink: '#FFFFFF', route: '#FFFFFF', elevation: '#FFFFFF', label: '#FFFFFF', logo: 'white', swatch: 'img/dark-contours.jpg' },
  { id: 'light-contours', name: 'Light Contours', legacyName: 'Light Contours', mapbox: mb('cl6yrb4za00bj15qofasrts1v'), bg: '#FFFFFF', frame: '#000000', ink: '#000000', route: '#000000', elevation: '#000000', label: '#000000', logo: 'black', swatch: 'img/light-contours.jpg' },
  { id: 'blueprint', name: 'Blueprint', legacyName: 'Blueprint', mapbox: mb('cl6orn7yd000214nvodw9als0'), bg: '#415EAF', frame: '#FFFFFF', ink: '#FFFFFF', route: '#FFFFFF', elevation: '#FFFFFF', label: '#FFFFFF', logo: 'white', swatch: 'img/blueprint.jpg' },
  { id: 'tangerine', name: 'Tangerine', legacyName: 'Tangerine', mapbox: mb('cl7rd3s8x003n14kb2ewxd90v'), bg: '#E95E2A', frame: '#FFFFFF', ink: '#FFFFFF', route: '#FFFFFF', elevation: '#FFFFFF', label: '#FFFFFF', logo: 'white', swatch: 'img/tangerine.jpg' },
  { id: 'satellite', name: 'Satellite', legacyName: 'Satelite', mapbox: mb('cl6nlme8b000014pqdpeihyzz'), bg: '#022129', frame: '#022129', ink: '#FFFFFF', route: '#FFFFFF', elevation: '#FFFFFF', label: '#FFFFFF', logo: 'white', swatch: 'img/satelite.jpg' },
  { id: 'sepia', name: 'Sepia', legacyName: 'Sepia', mapbox: mb('cl6c46s6t000a15nsna8jrhd7'), bg: '#FFECCB', frame: '#000000', ink: '#000000', route: '#CB1517', elevation: '#000000', label: '#CB1517', logo: 'black', swatch: 'img/sepia.jpg' },
  { id: 'old-world', name: 'Old World', legacyName: 'Old World', mapbox: mb('cl7rhs3y9005c15rys6eipngc'), bg: '#E2D9D3', frame: '#4E4137', ink: '#211C17', route: '#211C17', elevation: '#211C17', label: '#211C17', logo: 'white', swatch: 'img/old-world.jpg' },
  { id: 'outline', name: 'Outline', legacyName: 'Outline', mapbox: mb('ckkql4abf1jln17mmkku8sxdl'), bg: '#000000', frame: '#000000', ink: '#FFFFFF', route: '#FFFFFF', elevation: '#FFFFFF', label: '#FFFFFF', logo: 'white', swatch: 'img/outline.jpg' },
];

export const DEFAULT_STYLE: StyleId = 'midnight';

export const getStyle = (id: string | null | undefined): MapStyle =>
  STYLES.find((s) => s.id === id) ?? STYLES[0];

export const styleFromLegacyName = (name: string | null | undefined): StyleId =>
  STYLES.find((s) => s.legacyName.toLowerCase() === (name ?? '').trim().toLowerCase())?.id ?? DEFAULT_STYLE;
